// version.js
const { version } = require("../package.json");
module.exports = version;
